import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=61e5bea6&scoped=true"
import script from "./detailInfo.vue?vue&type=script&lang=js"
export * from "./detailInfo.vue?vue&type=script&lang=js"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=61e5bea6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e5bea6",
  null
  
)

export default component.exports